import { useMemo } from 'react'
import { useDocument, useLoading } from 'hooks'
import {} from 'domains/Color/hooks'

const useGetColorInitialValues = (id) => {
  // [DATA_FETCH]
  const [color, colorLoading] = useDocument({ ref: id ? `colors/${id}` : null })

  // [COMPUTED_PROPERTIES]
  const initialValues = useMemo(
    () => ({
      color
    }),
    [color]
  )
  const loadings = useMemo(
    () => (id ? [!color, colorLoading] : []),
    [id, color, colorLoading]
  )

  // [ADDITIONAL_HOOKS]
  const loading = useLoading(loadings)

  return [initialValues, loading]
}

export default useGetColorInitialValues
